import React from "react";
import "./VirusQuestions.scss";
import axios from "axios";
import { Toast } from "antd-mobile";
import Form from "../../components/Form";
import http from "../../util/api";

const record = {};
class VirusQuestions extends React.Component {
  constructor(props) {
    super(props);
    const id = this.props.match.params.id;
    const locationState = this.props.location.state;
    let personinfo, positionid;
    if (locationState && locationState.data) {
      personinfo = locationState.data;
      positionid = locationState.id;
    }
    this.state = {
      resid: id,
      personinfo,
      positionid
    };
  }

  componentDidMount() {
    this.getWXConfig();
  }
  getWXConfig = async () => {
    try {
      let url;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        url = window.location.href;
      } else if (isiOS) {
        url = window.wx_js_url || window.location.href;
      }
      let res = await axios.get(
        "http://kingofdinner.realsun.me:1201/api/wx/GetSignature",
        {
          params: {
            requesturl: url
          }
        }
      );
      if (res.data.error === 0) {
        let { data } = res.data;
        await window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.AppId, // 必填，公众号的唯一标识
          timestamp: data.Timestamp, // 必填，生成签名的时间戳
          nonceStr: data.NonceStr, // 必填，生成签名的随机串
          signature: data.Signature, // 必填，签名，见附录1
          jsApiList: ["startRecord", "stopRecord", "translateVoice"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        window.wx.ready(() => {});
        window.wx.error(res => {
          console.log("调用微信jsapi返回的状态:", res.errMsg);
        });
      } else {
        console.error("error:  " + res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleSubmit = async data => {
    const { positionid, resid } = this.state;
    Toast.loading("提交中...", 0);
    try {
      await http().addRecords({
        resid,
        data: [data]
      });
      Toast.hide();
      this.props.history.push("/appointment_position/" + positionid);
    } catch (error) {
      Toast.hide();
      Toast.fail(error.message);
    }
  };

  render() {
    const { resid } = this.state;
    return (
      <div className="virus-questions">
        <Form resid={resid} record={record} handleSubmit={this.handleSubmit} />
      </div>
    );
  }
}
export default VirusQuestions;
